import axios from "../http";

class OperatingIncome {
  getPrice(dateTime, warehouseId) {
    const url = `/zwy/api/order/count?dateTime=${dateTime}&warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  getNumberCount(dateTime, warehouseId) {
    const url = `/zwy/api/order/number/count?dateTime=${dateTime}&warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  postCostOperatingExcel(formData) {
    const url = `/zwy/api/upload/operate/employee/cost/ratio`;
    return axios.post(url, formData).then(res => {
      return Promise.resolve(res.data);
    });
  }
  postIncomeOperatingExcel(formData) {
    const url = `/zwy/api/upload/operate/employee/income/report`;
    return axios.post(url, formData).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default OperatingIncome;
